// Rating tiers, lowest to highest. The rating system itself is not built yet -
// this is just the ordered id list so the UI can show a player rank badge. The
// random pick below is a placeholder for the look; replace with the real rating
// lookup later.

export const RANKS = [
  'newbie',
  'hunter',
  'brawler',
  'veteran',
  'expert',
  'master',
  'champion',
  'legend',
] as const;

export type RankId = (typeof RANKS)[number];

// Placeholder: random tier each call. Swap for a real rating lookup later.
export function randomRank(): RankId {
  return RANKS[Math.floor(Math.random() * RANKS.length)]!;
}
